<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <label :for="id" class="control-label">{{ inputLabel }}</label>
    <slot :id="id">
      <input class="form-control form-group"
        v-model="value"
        :id="id"
        :type="type"
        style="text-align: right"
        :disabled="disabled"
        @change="$emit('change', $event.target.value)"
        @blur="$emit('blur', $event.target.value)"
    >
    </slot>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationFormMixin from '@/common/mixins/applicationFormMixin';
import applicationInputMixin from '@/common/mixins/applicationInputMixin';
import passInputMixin from '@/common/mixins/application-form/passInputMixin';

export default {
  name: 'DefaultInput',

  mixins: [
    applicationFormMixin,
    applicationInputMixin,
    passInputMixin
  ],

  model: {
    prop: 'modelValue'
  },

  props: {
    disabled: {
      default: () => false
    },

    inputLabel: {
      type: String,
      required: true
    },

    inputName: {
      default: ''
    },

    modelValue: {
    },

    type: {
      type: String,
      default: () => 'text'
    }
  },

  computed: {
    id () {
      return this._uid
    },

    value: {
      get () {
        return this.modelValue
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
